import { createFeatureSelector, createSelector, MemoizedSelector } from '@ngrx/store';
import { nameof } from '@symphony-solo/shared/utils/src';
import { ILoyaltyCardsFeature } from './loyalty-cards.feature.state';
import { LoyaltyCardsState } from './loyalty-cards.state';

export const getLoyaltyCardsState: MemoizedSelector<ILoyaltyCardsFeature, LoyaltyCardsState> = createFeatureSelector<LoyaltyCardsState>(
  nameof<ILoyaltyCardsFeature>('LoyaltyCardsFeature')
);

export const getLoyaltyCards = createSelector(getLoyaltyCardsState, (state: LoyaltyCardsState) => state.loyaltyCards);

export const isLoading = createSelector(getLoyaltyCardsState, (state: LoyaltyCardsState) => state.isLoading);

export const failures = createSelector(getLoyaltyCardsState, (state: LoyaltyCardsState) => state.failures);

export const getGoogleWalletPass = createSelector(getLoyaltyCardsState, (state: LoyaltyCardsState) => state.getGoogleWalletPass);

export const getAppleWalletPass = createSelector(getLoyaltyCardsState, (state: LoyaltyCardsState) => state.appleWalletPass);
